module.exports = __webpack_public_path__ + "img/line_dotted.c906dee0.svg";